import gql from 'graphql-tag'

export const serviceOrderStatusEnumValues = gql`
  query serviceOrderStatusEnumValues {
    __type(name: "ServiceOrderStatusEnum") {
      enumValues {
        name
      }
    }
  }
`
